import { Box, type SxProps, type Theme } from "@mui/material";
import type { ReactNode } from "react";

interface BoxGradientBorderProps {
  gradient: string;
  fallbackColor: string;
  borderSize: string;
  borderRadius?: string;
  innerBackground?: string;
  sx?: SxProps<Theme>;
  readonly children: ReactNode;
}

export const BoxGradientBorder = ({
  borderSize,
  borderRadius,
  gradient,
  fallbackColor,
  innerBackground = "#FFF",
  sx,
  children,
}: BoxGradientBorderProps) => {
  return (
    <Box
      sx={{
        ...sx,
        display: "inline-block",
        backgroundColor: fallbackColor,
        backgroundImage: gradient,
        padding: borderSize,
        borderRadius: borderRadius,
      }}
    >
      <Box
        sx={{
          backgroundColor: innerBackground,
          borderRadius: `calc(${borderRadius} - ${borderSize})`,
          width: "100%",
          height: "100%",
          "& > *, & > *::before, & > *::after": {
            borderRadius: "inherit",
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
